<template>
  <div class="meter-community-rate">
    <div class="fixed">
      <div class="header-order">{{ $t('序号') }}</div>
      <div class="header-item">{{ $t('小区名称') }}</div>
      <div class="header-item">{{ $t('抄见时间') }}</div>
      <div class="header-item">{{ $t('小区户数') }}</div>
      <div class="header-item">{{ $t('抄见户数') }}</div>
      <div class="header-item">{{ $t('抄见率') }}</div>
    </div>
    <div style="overflow: hidden;height: calc(100% - 40px);">
      <vue-seamless-scroll :data="list" class="seamless-warp" ref="seamlessScroll" :class-option="classOption" @ScrollEnd="ScrollEnd">
        <ul class="list-ul">
          <li class="list-row" v-for="(item, index) in list" :key="index">
            <div class="list-order">
              <div class="order">{{ index + 1 }}</div>
            </div>
            <div class="list-item">{{ item.name }}</div>
            <div class="list-item">{{ item.time }}</div>
            <div class="list-item">{{ item.num }}</div>
            <div class="list-item">{{ item.cnum }}</div>
            <div class="list-item">{{ item.rate }}</div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'MeterCommunityRate',
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      title: this.$t('小区远传表近7日抄见率'),
      url: {
        list: "/jeecg-engineering/ticket/tickets/list",
      },
      pageNo: 1,
      pageSize: -10,
      errorNum: 0,
      list: [
        {name:'社区1',time:'11-01 08:10',num:350,cnum:320,rate:'89%'},
        {name:'社区2',time:'10-01 08:10',num:400,cnum:400,rate:'100%'},
        {name:'社区3',time:'09-01 08:10',num:100,cnum:80,rate:'80%'},
        {name:'社区4',time:'11-01 08:10',num:450,cnum:402,rate:'85%'},
        {name:'社区5',time:'11-01 08:10',num:700,cnum:700,rate:'100%'},
        {name:'社区6',time:'11-01 08:10',num:800,cnum:777,rate:'87%'},
        {name:'社区7',time:'11-01 08:10',num:350,cnum:320,rate:'89%'},
        {name:'社区8',time:'11-01 08:10',num:350,cnum:320,rate:'89%'},
      ],
    }
  },
  computed: {
    goOn() {
      return this.errorNum < 5;
    },
    classOption() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.list.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    ScrollEnd() {
      // if(this.goOn) {
      //   this.getData()
      // }
    },
    init() {
      this.resetData()
      this.getData()
    },
    resetData() {
      this.list = []
    },
    getData() {
      getAction(this.url.list).then(res => {
        if (res.success) {
          if (res.result && res.result.xdata && res.result.ydata) {
            const data = []
            for (let i = 0; i < res.result.xdata.length; i++) {
              const num = res.result.ydata[i]?.num || 0
              const cnum = res.result.ydata[i]?.cnum || 0
              const rate = num > 0 ? Math.round((cnum / num) * 100) + '%' : '0%'
              
              data.push({
                name: res.result.xdata[i],
                time: '-',
                num: num,
                cnum: cnum,
                rate: rate
              })
            }
            this.list = data
          } else {
            this.list = this.$options.data.call(this).list
          }
        } else {
          this.list = this.$options.data.call(this).list
        }
      }).catch(() => {
        this.list = this.$options.data.call(this).list
      })
    },
  }
}
</script>

<style lang="less" scoped>
.meter-community-rate {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.fixed {
  display: flex;
  align-items: center;
  background-color: #08306F;
  color: #FFF;
  height: 30px;
}

.header-item {
  width: 17%;
  text-align: center;
}

.header-order {
  width: 15%;
  text-align: center;
}

.list-ul {
  padding-inline-start: 0;
}

.list-row {
  color: #b6deff;
  display: flex;
  align-items: center;
  height: 33px;
  line-height: 35px;
  border: 1px solid #011a3a;
}

.list-row .list-item {
  width: 17%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  color: #fff;
}

.list-order {
  width: 15%;
  display: flex;
  justify-content: center;
}

.order {
  width: 48px;
  height: 18px;
  border-radius: 2px;
  text-align: center;
  line-height: 18px;
  color: #fff;
}

.seamless-warp {
  height: 100%;
}

.seamless-warp:hover {
  overflow-y: scroll;
}

.seamless-warp::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.seamless-warp::-webkit-scrollbar-track {
  background: #0e0c4f;
  border-radius: 2px;
}

.seamless-warp::-webkit-scrollbar-thumb {
  background: #292f88;
  border-radius: 2px;
}

.seamless-warp::-webkit-scrollbar-corner {
  background: #0e0c4f;
}
</style>